export const ATS_SOURCES = [
  "Indeed",
  "Unstop",
  "Social Media | WhatsApp",
  "Consultancy",
];

export const ATS_SCREENING = ["YES", "NO"];

export const ATS_INT_STATUSES = [
  "R1 Scheduled",
  "Telephonic Interview done",
  "R1 done",
  "R1 Rejected",
  "R2",
];

export const emptyCandidateForm = {
  candidateName: "",
  jobProfile: "",
  callingRemark: "",
  source: "",
  screeningQualified: "",
  intStatus: "",
  locality: "",
  introRating: "",
};

export const candidateToForm = (candidate) => ({
  candidateName: candidate?.candidateName || "",
  jobProfile: candidate?.jobProfile || "",
  callingRemark: candidate?.callingRemark || "",
  source: candidate?.source || "",
  screeningQualified: candidate?.screeningQualified || "",
  intStatus: candidate?.intStatus || "",
  locality: candidate?.locality || "",
  introRating:
    candidate?.introRating === 0 || candidate?.introRating
      ? String(candidate.introRating)
      : "",
});
